import type { SubscriptionPlan } from '../interfaces/subscriptions';

export function normalizePublicPlans(plans: SubscriptionPlan[]): SubscriptionPlan[] {
  return plans.map((plan) => ({
    ...plan,
    price: Number(plan.price) || 0,
    frequency: Number(plan.frequency) || 1,
    trial_days: Number(plan.trial_days) || 0,
    features: Array.isArray(plan.features)
      ? plan.features.filter((item): item is string => typeof item === 'string')
      : [],
  }));
}

export function getLowestPlanPrice(plans: SubscriptionPlan[]): number | null {
  if (!plans.length) return null;
  return Math.min(...plans.map((plan) => Number(plan.price) || 0));
}
